import { defineComponent as _defineComponent } from 'vue'
import { sanitize } from 'dompurify';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ref } from 'vue';

import { computed } from 'vue';
import { useExperiment } from '@/libraries/experiment';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    value: null,
    placeholder: null,
    theme: { default: 'dark' }
  },
  emits: ["input", "submit", "focus", "arrow-down"],
  setup(__props: any, { expose, emit }: { emit: ({
	// for v-model
	(e: 'input', value: string): void;

	(e: 'submit'): void;
	(e: 'focus'): void;
	(e: 'arrow-down'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, placeholder: string, theme: 'dark' | 'light' };





// Used for keyboard navigation in SearchSuggesterBar.vue
const searchBarInput = ref<HTMLInputElement | null>(null);
expose({ searchBarInput });

// EXP_UK_HOME_2
const { activeVariant: ukHomeActiveVariant } = useExperiment('EXP_UK_HOME_2', 'global');
const usedTheme = computed(() => {
	if (ukHomeActiveVariant.value) {
		return 'transparent';
	} else {
		return props.theme;
	}
});
// EXP_UK_HOME_2

function updateSearchQuery(event: Event) {
	emit('input', sanitize((event.target as HTMLInputElement).value.trim()));
}

function submitSearch() {
	emit('submit');
	searchBarInput.value?.blur();
}

return { __sfc: true,props, emit, searchBarInput, ukHomeActiveVariant, usedTheme, updateSearchQuery, submitSearch, faTimes, faSearch }
}

})